define(function (require) {
    "use strict";


    /* ---------------------------------------------------------------------------------------------- */
    /* Dependencies Imports
     /* ---------------------------------------------------------------------------------------------- */

    var $ = require("jquery");
    var _ = require("underscore");
    var ck = require("ckeditor");
    var Modernizr = require("modernizr");
    var PositionUtils = require('ui/PositionUtils');
    var dialogDefinition = require("ui.plugins/rich-text-editor/js/dialogs/dialogDefinition");
    var Logger = require('logger');


    /* ---------------------------------------------------------------------------------------------- */
    /* Constants
    /* ---------------------------------------------------------------------------------------------- */

    var LINK_REGEX = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;

    var TOOLBAR_ITEMS = {
        BOLD: "Bold",
        ITALIC: "Italic",
        UNDERLINE: "Underline",
        DEVIDER: "-",
        LINK: "Link",
        SMILEY: "Smiley",
        COBROWSE: "CoBrowse"
    };

    /**
     * Mapping of the LiveEngage Language code to CKEditor Language codes.
     */
    var LOCALE_LANGUAGE_MAP = {
        "en-US": "en",
        "es-ES": "es",
        "de-DE": "de",
        "fr-FR": "fr",
        "it-IT": "it",
        "ja-JP": "ja",
        "ko-KR": "ko",
        "pt-BR": "pt-br",
        "zh-CN": "zh-cn",
        "tr-TR": "tr",
        "da-DK": "da",
        "fi-FI": "fi",
        "ru-RU": "ru",
        "ro-RO": "ro"
    };

    var PERMUTATION = {
        WEBAGENT: "webagent",
        STUDIO: "studio"
    };

    /**
     *
     * @type {{SMILEY: {name: string, standalone: boolean}, LINK: {name: string, standalone: boolean}}}
     */
    var DIALOGS = {
        SMILEY: {
            title: 'Smiley',
            name: 'smiley',
            standalone: true
        },
        LINK: {
            title: 'Link',
            name: 'link',
            standalone: true
        },
        COBROWSE: {
            title: 'CoBrowse',
            name: 'cobrowse',
            standalone: true
        }
    };

    var TOOLBAR_HEIGHT = 42;
    /**
     * the numbers corresponded with the 'location' of the Shift key from the keyPress event.
     * @type {{1: string, 2: string}}
     */
    var WRITE_DIRECTIONS            = {'1': 'ltr', '2': 'rtl' };         // list of write directions.
    var WRITE_DIRECTIONS_SOURCE     = { AUTODETECT:'AUTODETECT', MANUAL: 'MANUAL' };
    /**
     * Error Template for Unsanetized HTML.
     * @type {string}
     */
    var UNSANETIZED_ERROR_TEMPLATE = '<div class="editor-sanitize-message"><div class="error_icon"></div><div class="message">{{message}}</div></div>';

    var SANITATION_TYPES = {
        REPLACE: 'REPLACE',
        KEEP_AND_SHOW_WARNING: 'KEEP_AND_SHOW_WARNING'
    };

    /* ---------------------------------------------------------------------------------------------- */
    /* Helper Functions
     /* ---------------------------------------------------------------------------------------------- */

     var dummeyClonePlaceHolder;
    /**
     *
     * @param {Object} options - the options object
     * @returns {Object} - config object for the permutation.
     * @private
     */
    function _getConfigPermutation(options) {
        var retVal = {
            toolbar: [{name: options.permutation, items: options.settings.toolbar}],
            toolbarLocation: 'top',
            keystrokes: options.keystrokes
        };

        if (options && options.settings) {
            if (options.settings.plugins) {
                var enabledPlugins = [];
                for (var plugin in options.settings.plugins) {
                    var curPlugin = options.settings.plugins[plugin];
                    if (curPlugin.enabled) {
                        enabledPlugins.push(plugin);

                        if (plugin === 'cobrowse') {
                            retVal.cobrowse_menu_items = curPlugin.menuItems;
                        }

                        if (plugin === 'smiley') {
                            retVal.smiley = {
                                "conf": curPlugin.config,
                                "mode": curPlugin.mode
                            };
                        }
                    }
                }

                // extending the extra plugins.
                retVal.extraPlugins = enabledPlugins.join(',');
            }
        }

        return retVal;
    }

    /**
     *
     * @param permutation, String, - the Key of the permutation.
     * @returns {Object} - the combined config of the permutation.
     * @private
     */
    function _getConfigObject(options) {
        var configPermutation = _getConfigPermutation(options);

        var Config = {
            removeButtons: "",
            title: false,
            allowedContent: true,
            resize_enabled: false,
            dialog_backgroundCoverOpacity: 0,
            dialog_noConfirmCancel: true,
            disableObjectResizing: true,
            disableContextMenu: false,
            disableNativeSpellChecker: false,
            removePlugins: "",
            autoGrow_onStartup: true,
            autoGrow_minHeight: 55,
            autoGrow_maxHeight: 167,
            coreStyles_bold: {
                element: "span",
                styles: {"font-weight": "bold"},
                overrides: ["b", "strong"]
            },
            coreStyles_italic: {
                element: "span",
                styles: {"font-style": "italic"},
                overrides: ["i", "em"]
            },
            coreStyles_underline: {
                element: "span",
                styles: {"text-decoration": "underline"},
                overrides: "u"
            },
            useComputedState: true,
            blockedKeystrokes: [CKEDITOR.CTRL + CKEDITOR.SHIFT, CKEDITOR.CTRL + 66].concat(options.blockedKeystrokes || []),
            enterMode: CKEDITOR.ENTER_BR
        };

        return _.extend({}, Config, configPermutation, options.configOverride);

    }

    /**
    * create a place holder element for cloned elements in order
    * to overcome DOM Parser limitation on invisible elements
    * @private
    */
    function createClonePlaceHolder(){
        if(!dummeyClonePlaceHolder){
            dummeyClonePlaceHolder = document.createElement('div');
            dummeyClonePlaceHolder.id = 'LE_CKE_ContainerPH';
            dummeyClonePlaceHolder.style.position = "absolute";
            dummeyClonePlaceHolder.style.top = "-3000px";
            dummeyClonePlaceHolder.style.left = "-3000px";
            document.body.appendChild(dummeyClonePlaceHolder);
        }
    }

    /**
    * get the container
    * @returns {HTMLElement} - the the HTMLElement container for cloned elements
    * @private
    */
    function getClonePlaceHolder(){
        return dummeyClonePlaceHolder;
    }

    /**
    * clear the cloned element container
    * @private
    */
    function clearClonePlaceHolder(){
        if(dummeyClonePlaceHolder){
            dummeyClonePlaceHolder.innerHTML = '';
        }
    }



    /* ---------------------------------------------------------------------------------------------- */
    /* Rich Text Editor Class
     /* ---------------------------------------------------------------------------------------------- */

    /**
     * create a new instance of CKEditor
     * @param options
     * @returns {{render: render, scrollTop: scrollTop, scrollBottom: scrollBottom, setEnabled: setEnabled, setFocus: setFocus, setValue: setValue, clear: clear, insertHTML: insertHTML, insertText: insertText, getValue: getValue, getEditableContainer: getEditableContainer, close: close}}
     * @constructor
     */
    function RichTextEditor(options) {
        // Creating the global placeholder for the cloned elements.
        createClonePlaceHolder();

        var logger = Logger.getLogger('RichTextEditor');

        /* ---------------------------- Private Variables -------------------------- */

        options = options || {};

        var writeDirection = null;                              // store the current write direction.
        var ckeditor = null;                                    // the ckeditor internal instance.
        var oldValue = null;                                    // store the old value of the editor. for change events.

        var events = options.events || {};                      // list of events to bind.
        var delegates = options.delegates || {};                // list of delegations functions, such as the HTML filter.
        var configObj = _getConfigObject(options);  // the configuration object for the CKEditor instance.

        var currentDialog = null;                               // store the current dialog instance.
        var dialogElements = {};                                //

        var locale = options.locale || "en-US";                 // default local
        var language = _.has(LOCALE_LANGUAGE_MAP, locale) ? LOCALE_LANGUAGE_MAP[locale] : LOCALE_LANGUAGE_MAP["en-US"];

        configObj.height = options.height || 55;                // the default height of the container.
        configObj.language = language;                          // setting the language code.

        var ckeditorHeight = configObj.height + TOOLBAR_HEIGHT; // defining the default editor height for the first resize event.
        var writeDirectionStrategy = WRITE_DIRECTIONS_SOURCE.AUTODETECT;    // Setting the default write direction strategy.


        /* ---------------------------- Global Configuration -------------------------- */

        CKEDITOR.document.getBody = _getBody;
        CKEDITOR.dom.element.prototype.disableContextMenu = function () {
        };

        // adding sanitation markers.
        CKEDITOR.config.protectedSource.push(/<IFRAME[\s\S]*?>[\s\S]*?<\/IFRAME>/gi);
        CKEDITOR.config.protectedSource.push(/<SCRIPT[\s\S]*?>[\s\S]*?<\/SCRIPT>/gi);
        CKEDITOR.config.protectedSource.push(/<STYLE[\s\S]*?>[\s\S]*?<\/STYLE>/gi);
        CKEDITOR.config.protectedSource.push(/<LINK[\s\S]*?>[\s\S]*?<\/LINK>/gi);
        CKEDITOR.config.protectedSource.push(/<META[\s\S]*?>[\s\S]*?<\/META>/gi);

        // disabling escape of basic entities [for more information go to here - http://docs.cksource.com/ckeditor_api/symbols/src/plugins_entities_plugin.js.html]
        CKEDITOR.config.entities = false;


        /**
         * Toggle the availability of the Button.
         * @param name - the name of the button / command
         * @param isActive - true/false
         */
        function setButtonActiveMode(name, isActive) {
            if (ckeditor.readOnly) {
                return;
            }
            var state = isActive ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED;
            var button = getToolbarButtonElement(name);
            var command = ckeditor.commands[name];

            if (button) {
                button.setState(state);
            }
            if (command) {
                command.setState(state);
            }
        }

        function getToolbarButtonElement(name) {
            if (ckeditor.toolbar && ckeditor.toolbar.length && ckeditor.toolbar[0].items) {
                for (var i = 0; i < ckeditor.toolbar[0].items.length; i++) {
                    if(ckeditor.toolbar[0].items[i].hasOwnProperty('name') && ckeditor.toolbar[0].items[i].name === name)
                    {
                        return ckeditor.toolbar[0].items[i];
                    }
                }
            }
        }

        /**
         * render's the CKEditor into the supplied container.
         * @param element
         * @param doneCallback
         */
        function render(element, doneCallback) {
            var instanceConfig = _.clone(configObj);

            // register to the instance ready event, this will fire the custom load event
            // indicating that the instance is ready for use.
            instanceConfig.on = configObj.on || {};
            instanceConfig.on.instanceReady = function () {
                clear();
                doneCallback();
                events.load();
            };

            // converting the text area to CKEditor instance
            ckeditor = CKEDITOR.replace(element, instanceConfig);

            // binding all the events.
            bindEditorInstanceEvents();
        }

        /**
         * bind all the Editor Related Events.
         */
        function bindEditorInstanceEvents() {

            /* -------- events -----------*/

            ckeditor.on("contentDom", onContentDomReady);
            ckeditor.on("loaded", onEditorLoaded);
            ckeditor.on("dialogShow", onDialogShow);
            ckeditor.on("dialogHide", onDialogHide);
            ckeditor.on("resize", onResize);
            ckeditor.on("change", onChange);
            /* -------- handlers -----------*/

            function onContentDomReady(evt) {
                bindEditableEvents();
            }

            function onEditorLoaded(evt) {
                // Appending the current permutation css styling.
                ckeditor.container.addClass("permutation-" + options.permutation);
                $(ckeditor.container.$).find(".cke_button").css("background", ""); // remove the default background that ckeditor sets inline
                $(ckeditor.container.$).find(".cke_button_icon").css("background", ""); // remove the default background that ckeditor sets inline

                ckeditor.lang.link.noUrl = "";

                // overriding the move function on the dialogs to support the autoGrow plugin.
                var originalMove = CKEDITOR.dialog.prototype.move;
                CKEDITOR.dialog.prototype.move = function () {
                    originalMove.apply(this, arguments);
                    _setDialogPosition();
                };

                CKEDITOR.on("dialogDefinition", dialogDefinition);

                ckeditor.keystrokeHandler.keystrokes = mergeKeyStrokes(ckeditor.keystrokeHandler.keystrokes, configObj.keystrokes);
            }

            /**
             * Get merged shortcuts. Merge between the default editor shortcuts and given config shortcuts.
             * @param editorKeyStrokes - Object of keyCode:plugin (plugin is a string like link, bold) - Editor's default shortcuts
             * @param confKeyStrokes - Array of [[keycode, plugin], []] (plugin is a string like link, bold) -  given configuration shortcuts to override editor's default shortcuts
             * @returns {*} merged shortcuts
             */
            function mergeKeyStrokes(editorKeyStrokes, confKeyStrokes) {
                if(Array.isArray(confKeyStrokes) && editorKeyStrokes) {
                    var keyCode, plugin;
                    confKeyStrokes = confKeyStrokes || [];

                    for (var i = 0; i < confKeyStrokes.length; i++) {
                        if (confKeyStrokes[i]) {
                            keyCode = confKeyStrokes[i][0];
                            plugin = confKeyStrokes[i][1];
                            if (plugin) {
                                editorKeyStrokes[keyCode] = plugin;
                            } else if (editorKeyStrokes[keyCode]) {
                                delete editorKeyStrokes[keyCode];
                            }
                        }
                    }
                }

                return editorKeyStrokes;
            }

            function onDialogShow(evt) {
                currentDialog = evt.data;
                var dialogName = currentDialog.getName();

                if (currentDialog) {

                    var dialogSettings = DIALOGS[dialogName.toUpperCase()];

                    // LE-27215: if we opening a new dialog while another dialog is open, it's automatically assign as the child of the opened dialog.
                    // to fix this, we will check the dialog properties for "standalone" flag, if it's on we will close tha parent *(that will also close the child's) and reopen the dialog.
                    if (dialogSettings && currentDialog._ && currentDialog._.parentDialog) {
                        var pDialog = currentDialog._.parentDialog;

                        // if we clicked on the same dialog, closing the dialog [toggle behaviour]
                        if (pDialog === currentDialog) {
                            // we need to manually reset the parent dialog on the current dialog
                            // cke will not remove the parenting and will references to itself and create a infinite loop
                            currentDialog._.parentDialog = null;
                            pDialog.hide();
                            evt.cancel();
                            return;
                        }

                        if (dialogSettings && dialogSettings.standalone) {
                            pDialog.hide();
                            // need to be delayed because the CKEditor still see the current dialog as the parent until the event's flow ends.
                            setTimeout(function () {
                                ckeditor.openDialog(dialogName);
                            }, 0);
                            return;
                        }
                    }

                    dialogElements[dialogName] = currentDialog;
                    _setDialogPosition();
                    _bindDialogEvents();

                    // to resolve the caret moving one char backwards when starting to write
                    // after opening the smiley dialog, also help make unified experience in all browsers
                    // that we can write even though the smiley dialog is open
                    if (dialogName === DIALOGS.SMILEY.name) {
                        delayedSetFocus();
                    }
                }
            }

            function onDialogHide(evt) {
                currentDialog = null;
                _bindDialogEvents();
                setFocus();
            }

            function onResize(evt) {
                if (events.resize && _.isFunction(events.resize)) {
                    if (_.isNull(ckeditorHeight)) {
                        ckeditorHeight = $(ckeditor.container.$).height();
                    }

                    var newHeight = $(ckeditor.container.$).height();
                    if (newHeight === 0) {
                        newHeight = ckeditorHeight;
                    }

                    var diff = newHeight - ckeditorHeight;
                    //for some reasons sometimes FF calculates a negative diff onLoad
                    //diff = diff < 0 ? 0 : diff;
                    if (diff !== 0) {
                        _setDialogPosition();
                        ckeditorHeight = newHeight;
                        var eventData = {newHeight: ckeditorHeight, diff: diff};
                        if (events.resize) {
                            events.resize(eventData);
                        }
                    }
                }
            }

            function onChange(event) {
                var newValue = ckeditor.getData();
                var eventData = {
                    event: event,
                    oldValue: oldValue,
                    newValue: newValue
                };
                if(eventData.oldValue !== eventData.newValue) {
                    if (events && events.change && _.isFunction(events.change)) {
                        events.change(eventData);
                    }
                    oldValue = newValue;

                    if(writeDirectionStrategy === WRITE_DIRECTIONS_SOURCE.AUTODETECT && delegates.detectTextDirection ){
                        var plainText = $.trim(getTextValue());
                        if(_.isEmpty(plainText)){
                            // clear the write direction flag
                            writeDirectionStrategy = WRITE_DIRECTIONS_SOURCE.AUTODETECT;
                            setWritingDirection(writeDirection, true, WRITE_DIRECTIONS_SOURCE.AUTODETECT);
                        } else {
                            // Language direction detection + switching language.
                            var direction = delegates.detectTextDirection(plainText, writeDirection);
                            setWritingDirection(direction.key, false, WRITE_DIRECTIONS_SOURCE.AUTODETECT);
                        }
                    }

                    event.editor.fire('resize');
                }
            }
        }

        /**
         * binding all User Interaction's related events.
         */
        function bindEditableEvents() {
            var capabilities = options.settings && options.settings.capabilities;
            var editable = ckeditor.editable();

            /* -------- events -----------*/
            ckeditor.on('cut', onCut, ckeditor.element.$);
            ckeditor.on('afterSetData', onAfterSetData, ckeditor.element.$);
            ckeditor.on('key', onKeyPress, ckeditor.element.$);

            if (Modernizr.isedge) { // [LE-37218] This is a workaround for pasting content in Windows10-Edge. more details can be found on the "onEdgePaste" method.
                editable.attachListener(editable, 'paste', onEdgePaste);
            } else {
                ckeditor.on('paste', onPaste, ckeditor.element.$);
            }

            editable.attachListener(editable, 'drop', preventDrop);
            editable.attachListener(editable, 'click', onClick);
            editable.attachListener(editable, 'keyup', onKeyUp);
            editable.attachListener(editable, 'keydown', onKeyDown);

            // LE-42996 - Supporting IME (External Input source).
            editable.attachListener(editable,'compositionstart', onCompositionEvent, false);
            editable.attachListener(editable,'compositionupdate', onCompositionEvent, false);
            editable.attachListener(editable,'compositionend', onCompositionEvent, false);


            /* ----- internal handlers -------*/

            function getHTMLFromDataTransferObject(data, filter) {
                if (data && data.dataValue) {
                    if (isLinkPluginEnabled() && LINK_REGEX.test(data.dataValue)) {
                        var linkTag = '<a href="{href}" target="_blank" >{href}</a>'.replace(/{href}/g, data.dataValue);
                        return {html: linkTag};
                    }

                    // NOTE: due to the massive changes in the api, for now we treating all sources as HTML input.
                    //if (data.type === 'html') {
                    if (delegates && delegates.processHTMLData) {
                        var processedHTML = delegates.processHTMLData(data.dataValue, filter);
                        if (!_.isEmpty(processedHTML)) {
                            return {html: processedHTML};
                        }
                    }
                }

                function isLinkPluginEnabled(){
                    return configObj.toolbar[0] && configObj.toolbar[0].items && configObj.toolbar[0].items.indexOf(TOOLBAR_ITEMS.LINK) > 0;
                }
            }

            /* -------- handlers -----------*/
            function _okKeyPress(eventData) {
                var nativeEvent = eventData.event.data.domEvent.$;
                // Direction Switch
                if (nativeEvent.ctrlKey && nativeEvent.shiftKey) {
                    var direction = nativeEvent.location || nativeEvent.keyLocation;
                    setWritingDirection(direction, false, WRITE_DIRECTIONS_SOURCE.MANUAL);
                }
            }

            function onClick(e) {
                var originalEvent = e.data.$;
                var target = originalEvent.target || originalEvent.relatedTarget || originalEvent.srcElement;
                if (target === editable.$) {
                    setFocus();
                }
            }

            function onKeyUp(evt) {
                var event = evt.data.$;
                var eventData = {
                    event: evt,
                    keyCode: event && event.keyCode
                };
                if (events.keyUp && _.isFunction(events.keyUp)) {
                    events.keyUp(eventData);
                }
            }

            function onKeyDown(evt) {
                var event = evt.data.$;
                var eventData = {
                    keyCode: event && ('which' in event) ? event.which : event.keyCode,
                    event: evt
                };
                if (events.keyDown && _.isFunction(events.keyDown)) {
                    events.keyDown(eventData);
                }
            }

            function onKeyPress(event) {
                var eventData = {
                    event: event,
                    keyCode: event && event.data && event.data.keyCode
                };
                // calling the internal handler on the key press event.
                // currently using to change writing direction and suppress backspace when the editor is 'empty'.
                _okKeyPress(eventData);

                if (events.keyPress && _.isFunction(events.keyPress)) {
                    events.keyPress(eventData);
                }
            }

            /**
             * Composition event is for IME Input (japanese, korean, and auto-complete editors).
             * this event will handle all three events (start, update, end).
             */
            function onCompositionEvent(){
                ckeditor.fire('change');
            }

            /**
             * The purpose of this method is to capture the raw content from the clipboard, extract it in plain-text mode to serve it to our standard pasting mechanism.
             * It was born from the limitation we found in Windows10-Edge where the standard call to ckeditor.on('paste', onPaste, ckeditor.element.$); failed
             * to called when pasting content was performed.
             * We DO NOT assign all the browsers to this method at the moment since it raised a different limitation in copy/paste content from within the CKEditor, it loses all styles.
             * @param evt
             */
            function onEdgePaste(evt) {
                var rawEvent = evt.data.$;
                var clipboardContent = rawEvent.clipboardData.getData('text/plain');
                if (clipboardContent) {
                    evt.data.dataValue = clipboardContent;
                    onPaste(evt);
                }
                evt.data.preventDefault(true);
                evt.cancel();
                evt.stop();
            }

            function onPaste(evt) {
                // Prevent data pasting when not in focus on the editor.
                if (ckeditor.focusManager.hasFocus && capabilities && capabilities.clipboard && capabilities.clipboard.enabled && capabilities.clipboard.mode) {
                    switch (capabilities.clipboard.mode) {
                        case 'plain':
                            if (evt.data && evt.data.dataValue) {
                                if(capabilities.clipboard.notificationHandler) {
                                    capabilities.clipboard.notificationHandler();
                                }
                                insertText(getCleanText(evt.data.dataValue));
                            }
                            break;
                        case 'html':
                            if(capabilities.clipboard.filter) {
                                var proccessedHTML = getHTMLFromDataTransferObject(evt.data, capabilities.clipboard.filter);
                                if(proccessedHTML && capabilities.clipboard.notificationHandler){
                                    capabilities.clipboard.notificationHandler();
                                }
                                insertHTML(proccessedHTML);
                            }
                            break;
                    }
                    ckeditor.fire('change');
                }
                evt.cancel();
                return false;
            }

            function onCut(evt) {
                ckeditor.fire('change');
            }

            function onAfterSetData(evt) {
                writeDirectionStrategy = WRITE_DIRECTIONS_SOURCE.AUTODETECT;
                ckeditor.resetUndo();
            }

            function preventDrop(evt) {
                evt.data.preventDefault(true);
                evt.cancel();
                evt.stop();
            }
        }

        /**
         * setting the instance direction variable to save the direction
         * @param direction
         */
        function setWritingDirection(direction, forceSwitch, directionStrategy) {
            // only manual is supported after the agent has determined to control the language direction. (after set date the manual override is reset.)
            if(writeDirectionStrategy === WRITE_DIRECTIONS_SOURCE.MANUAL && (typeof directionStrategy !== 'undefined' && directionStrategy !== WRITE_DIRECTIONS_SOURCE.MANUAL)){
                return;
            }

            // same direction, no switch unless we forcing it.
            if (writeDirection && direction === writeDirection && (typeof forceSwitch !== 'undefined' && !forceSwitch)) {
                return;
            }

            writeDirection = direction;
            if(directionStrategy){
                writeDirectionStrategy = directionStrategy;
            }

            if (WRITE_DIRECTIONS[direction] === 'rtl') {
                ckeditor.commands.bidirtl.exec(ckeditor);
            }
            else {
                ckeditor.commands.bidiltr.exec(ckeditor);
            }
        }

        /**
         * Scrolling top on the Editor.
         * @returns {*}
         */
        function scrollTop() {
            if (ckeditor) {
                var element = $(ckeditor.ui.space("contents").$);
                return element.scrollTop(0);
            }
        }

        /**
         * Scrolling Button on the Editor.
         * @returns {*}
         */
        function scrollBottom() {
            if (ckeditor) {
                var eContainer = getEditableContainer();
                if (eContainer) {
                    var pContainer = eContainer.parentElement;
                    if (pContainer) {
                        var pHeight = parseInt(getComputedStyle(pContainer).height, 10);
                        pContainer.scrollTop = pContainer.scrollHeight - pHeight;
                    }
                }
            }
        }

        /**
         * Set's the editor Enabled mode
         * NOTICE: Direct relation to ReadOnly flag.
         * @param mode
         */
        function setEnabled(mode) {
            if (ckeditor) {
                ckeditor.setReadOnly(!mode);
            }
        }


        /**
         * return the Enabled state of the editor
         * @returns {boolean}
         */
        function getEnabled() {
            return ckeditor.readOnly;
        }

        /**
         * Setting the focus on the Editor.
         */
        function setFocus(delayed) {
            if (delayed) {
                delayedSetFocus();
            } else {
                ckeditor.focus();
            }
        }

        /**
         * Setting the focus on the Editor.
         * Performed with a timeout to make sure the editor is visible so the change will take effect.
         */
        function delayedSetFocus() {
            var editableContainer = getEditableContainer();
            if (editableContainer) {
                $(editableContainer).focus(0);
            }
        }

        /**
         * Clear the Editor Value.
         * @param cb
         */
        function clear(cb) {
            if (!cb) {
                cb = function emptyCallBack() {
                };
            }
            setValue(null, cb);
        }

        /**
         * this is a workaround for the CKEditor Ghost Element Bug (​"&#8203;" text element), this will travels the container of the content
         * element and search non HTML element that effect the UI Behaviour and create some quirky situations.
         *
         * in general - the container should only contain the HTMLContentEditable Div.
         */
        function clearGhostElements() {
            var i, eContainer = getEditableContainer(), container = eContainer && eContainer.parentElement;

            if (container && container.childNodes && container.childNodes.length > 1) {
                var removeElementsList = [];

                for (i = 0; i < container.childNodes.length; i++) {
                    if (!(container.childNodes[i] instanceof HTMLElement)) {
                        removeElementsList.push(container.childNodes[i]);
                    }
                }

                if (removeElementsList.length) {
                    for (i = 0; i < removeElementsList.length; i++) {
                        container.removeChild(removeElementsList[i]);
                    }
                    // call the onChange event to fire the height change.
                    ckeditor.fire('resize');
                }

                removeElementsList = null;
            }
        }

        /**
         * Setting the Editor Value.
         * if the value is empty, we will assign an empty span tag.
         * @param text
         * @param cb
         */
        function setValue(text, cb) {
            var setDataOptions = {
                callback: function () {
                    fireCallback();
                },
                internal: false
            };

            function fireCallback() {
                if (text) {
                    _cursorEnd();
                }
                if (_.isFunction(cb)) {
                    cb();
                }
                clearGhostElements();
            }

            var currentValue = ckeditor.getData();
            if (currentValue === text) {
                fireCallback();
            }
            else if (!text) {
                ckeditor.setData('<span></span>', setDataOptions);
            }
            else {
                ckeditor.setData(text, setDataOptions);
            }
        }

        /**
         * Insert HTML at the caret position.
         * @param options
         */
        function insertHTML(options) {
            /*

             we need to resolve 2 problems:
             1) inserting HTML without Root Element.
             2) prevent XSS on the Agent Workspace and to preserve the Pre Defined Content if it has XSS/Invalid HTML.

             #1: Content Wrapping:
             =====================
             we need to warp every html content sent to this function with a specific
             div container that will be strip when we ask for the value. notice that the container is a div marked with data
             attribute.
             note: previously it was a custom tag that allow us to use RegEx for fast Removal - but the CKEditor didn't like it and cause some problem with the Redo/Undo module.

             <p>content</p>             | => | <section data-type="external-html">
             <a href="#">click me</a>   | => |    <p>content</p>
             '                          | => |    <a href="#">click me</a>
             '                          | => | </section>


             #2: Sanitation Protection:
             =========================
             to solve the second problem - we extend the function to get a 'Sanitize' flags, indicating the needed sanitize behavior.
             we have 2 ways we can chose:
             'REPLACE' : will replace the html with the sanitized html.
             'KEEP_AND_SHOW_WARNING' : will preserve the original value, and show a message determined by the consumer of this lib - the original value will be saved as encoded html inside
             data attribute for extraction when we need to get the value.

             */

            var html = options && options.html;   // Html Value.
            //var sanitize            = ( options && options.sanitize )         || false                        ;   // Enable Sanitation.
            var sanitationType = ( options && options.sanitationType ) || SANITATION_TYPES.REPLACE;   // The type of output after the sanitation.
            var sanitizeFunc = options.sanitizeFunc || delegates.sanitize;   // Sanitize Function.
            var sanitizeMessage = options.sanitizeMessage;   // the message to display if the content was needed sanitation.
            var convertToPlainText = options.convertToPlainText || false;   // if true, convert the data into plain text
            if (ckeditor && !_.isEmpty(html)) {
                var retHTML = html;
                if (sanitizeFunc) { // If we were requested to sanitize the text, we pass it to insertHtml that takes the protectedSource configuration into account
                    var sanitizedTest = sanitizeFunc(html);
                    if (sanitizedTest.sanitized) {
                        if (sanitationType === SANITATION_TYPES.REPLACE) {
                            retHTML = sanitizedTest.text;
                        } else if (sanitationType == SANITATION_TYPES.KEEP_AND_SHOW_WARNING)
                        {
                            retHTML = _getWrappedSanitizedHTML(html, sanitizeMessage);
                        }
                    } else {
                        retHTML = html;
                    }
                }

                if (convertToPlainText) {
                    insertText(getCleanText(retHTML));
                } else if (retHTML) {
                    var element = CKEDITOR.dom.element.createFromHtml(_getWrappedExternalHTML(retHTML));
                    ckeditor.insertElement(element);
                    clearGhostElements();
                    element = null;
                }
            }

            function _getWrappedExternalHTML(html) {
                return ['<span>', html, '</span>'].join('');
            }

            function _getWrappedSanitizedHTML(html, msg) {
                var warningMsgHtml = UNSANETIZED_ERROR_TEMPLATE.replace('{{message}}', msg);
                var sanitizedHtmlContainer = "<section contenteditable='false' data-type='sanitized-block' data-sanitized-content='{{sanitizedContent}}' >{{message}}</section>";
                return sanitizedHtmlContainer.replace('{{sanitizedContent}}', _.escape(html)).replace('{{message}}', warningMsgHtml);
            }
        }

        /**
         * Insert Text content in the caret position.
         * @param text
         */
        function insertText(text) {
            if (ckeditor && !_.isEmpty(text)) {
                ckeditor.insertText(text);
                clearGhostElements();
            }
        }

        /**
         * get's the editor Value.
         * @param isUnsenetized - add the senetized value
         * @param removeUIMessages
         * @returns {*}
         */
        function getValue(isSanitized, isCustomeTagsIncluded) {
            if (ckeditor) {
                return _proccessCustomElements(ckeditor.getData());
            }
            /**
             * go over the html elements and process them.
             * @param html - full html value from the CKEditor.
             * @returns {String} - precessed html for output.
             * @private - handling the custom elements processing.
             */
            function _proccessCustomElements(html) {
                // Parsing the HTML inside the html text to resolve the tree of content.
                var $html = $('<div />').html(html);

                // #1: sanitized HTML Blocks unwrapping
                handleSanitation();

                // #2: Unwrapping the HTML inside the 'External' Html.
                handleExternalHtmlBlocks();

                // #3: Protecting HeyperLinks with the "noopener" rel.
                $('A',$html).attr("rel", "noopener").attr("target","_blank");

                // #4: Converting the HTML into string
                // this step is important, in order to inject the original string that may contain XSS injection, we must to serialize the HTML
                // and do the manipulation in string format in order to not invoke any script.
                var retVal = $html.html();

                // #4: Removing the Marked Comments Wrapping
                retVal = retVal.replace(/(<!--{Sanitized}(.*?){\/Sanitized}-->)/g, function (match, $1, $2) {
                    return _.unescape($2);
                });

                return retVal;

                /* =-------- Privates --------= */
                function handleSanitation() {
                    if (isSanitized) {
                        var sanitizedHtmlBlocks = $html.find('[data-type="sanitized-block"]');
                        for (var i = 0; i < sanitizedHtmlBlocks.length; i++) {
                            if (isSanitized) {
                                sanitizedHtmlBlocks[i].outerHTML = '<!--{Sanitized}{{html}}{/Sanitized}-->'.replace('{{html}}', _.escape(sanitizedHtmlBlocks.eq(i).data('sanitized-content')));//  '<strong>this will be the sanitized html</strong>';
                            } else {
                                sanitizedHtmlBlocks[i].outerHTML = '';
                            }
                        }
                    }
                }
                function handleExternalHtmlBlocks() {
                    if (!isCustomeTagsIncluded) {
                        var externalHtmlBlocks = $html.find('[data-type="external-html"]');
                        for (var i = 0; i < externalHtmlBlocks.length; i++) {
                            try {
                                externalHtmlBlocks[i].outerHTML = externalHtmlBlocks.eq(i).html();
                            }
                            catch (e) {
                                var message = 'Inner exception while handling external HTML.';
                                if (e) {
                                    if (e.message) {
                                        message += ' Message: ' + e.message;
                                    }
                                }
                                logger.warn(message);
                            }
                        }
                    }
                }

            }
        }

        function getTextValue(processHandler) {
            var ph,
            retVal = '',
            container = getEditableContainer();

            if (container) {
                // clone the node.
                if(typeof processHandler === "function") {
                    container = container.cloneNode(true);
                    // Attach the cloned element into the DOM in
                    // order the get the correct innerText value
                    // in browser that uses DOM Parser / Selections
                    // Like FF
                    ph = getClonePlaceHolder();
                    ph.appendChild(container);
                    processHandler(container);
                }
                retVal = container.innerText || container.textContent;

                // Clearing all of the non-braking markers.
                // See refrences at the bottom of the file.
                retVal = retVal.replace(/[\u200b\ufeff]/g,'');

                // Clear the placeholder if was used.
                if(ph) {
                    clearClonePlaceHolder();
                }

            }
            // LE-90071: Firefox return a return carriage in addition to the text, triming the end of the message.
            return CKEDITOR.tools.rtrim(retVal);
        }

        /**
         * Getting the Editor editablecontent Dom Element
         * @returns DOMElement
         */
        function getEditableContainer() {
            return ckeditor.editable().$;
        }

        /**
         * Disposing the Editor.
         */
        function close() {
            currentDialog = null;
            if (ckeditor) {
                ckeditor.destroy();
            }
        }

        /**
         * Get's the Body Element of the Editor Container.
         * @returns {CKEDITOR.dom.element}
         * @private
         */
        function _getBody() {
            return new CKEDITOR.dom.element($(".interaction-area-item-wrapper.open").get(0));
        }

        /**
         * Setting the dialog positions.
         * @private
         */
        function _setDialogPosition() {
            if (currentDialog) {
                var pluginName = currentDialog.getName();
                var buttonHTMLObj = $(ckeditor.container.$).find(".cke_button__" + pluginName);
                var dialogHTMLObj;
                var dialogHTMLObjSelector = ".interaction-area-item-wrapper.open";
                if (ckeditor.id) {
                    dialogHTMLObjSelector += " ." + ckeditor.id;
                }
                dialogHTMLObj = $(dialogHTMLObjSelector).find(".cke_dialog_" + pluginName);
                dialogHTMLObj.css("top", "");
                dialogHTMLObj.css("left", "");
                PositionUtils.position(
                    {
                        targetEl: buttonHTMLObj,
                        floatingEl: dialogHTMLObj,
                        position: PositionUtils.PositionEntity.POSITION.TOP,
                        align: PositionUtils.PositionEntity.ALIGN.RIGHT
                    },
                    function (obj) {
                        var leftAligned = (obj.cls.indexOf("align-left") > -1);
                        dialogHTMLObj.toggleClass("align-left", leftAligned);

                        if (leftAligned) {
                            dialogHTMLObj.css({"top": obj.top - 2, "left": obj.left - 13});
                        }
                        else {
                            dialogHTMLObj.css({"top": obj.top - 2, "left": obj.left + 13});
                        }
                    }
                );
            }
        }

        /**
         * binding the dialog Events.
         * @private
         */
        function _bindDialogEvents() {
            _.each(dialogElements, function (dialog) {
                $(dialog.getElement().getFirst().$).unbind("clickoutside");
                if (currentDialog && currentDialog.getName() === dialog.getName()) {
                    $(dialog.getElement().getFirst().$).bind("clickoutside", function (e, clickedObject) {
                        if (!$(clickedObject).hasClass("cke_button_icon")) {
                            _.defer(function () { // defered because sometimes other code affect the ck and can close it before this code runs
                                if (currentDialog && currentDialog.getButton("cancel")) {
                                    currentDialog.getButton("cancel").click();
                                }
                            });
                        }
                    });
                }
            });
        }

        /**
         * setting the Editor caret at the end.
         * @private
         */
        function _cursorEnd() {
            var range = ckeditor.createRange();
            var selector = ckeditor.getSelection();
            range.moveToElementEditEnd(range.root);
            selector.selectRanges([range]);

            // this is ugly!! but the scroll is jumping for unknown reason if this action is not deferred.
            // need to find the reason of the jump to remove the delay.
            setTimeout(scrollBottom, 200);
        }

        function getCleanText(htmlString) {
            return transformHTMLToPlainText(htmlString);

            function transformHTMLToPlainText(htmlString){
                if(htmlString){
                    htmlString = htmlString.replace(/<br\s*[\/]?>/gi, "\n");
                    return stripHTML(htmlString);
                }
            }

            function stripHTML(htmlString){
                var regex = /(<([^>]+)>)/ig
                    ,   body = htmlString
                    ,   result = body.replace(regex, "");
                return result;
            }
        }

        function getToolbarElement() {
            var topSpace = ckeditor.ui.space('top');
            if (topSpace && topSpace.$) {
                return topSpace.$;
            }
        }

        function blur(){
            ckeditor.fire('blur');
        }

        return {
            render: render,
            scrollTop: scrollTop,
            scrollBottom: scrollBottom,
            setEnabled: setEnabled,
            setFocus: setFocus,
            setValue: setValue,
            blur: blur,
            getEnabled: getEnabled,
            clear: clear,
            insertHTML: insertHTML,
            insertText: insertText,
            getValue: getValue,
            getTextValue: getTextValue,
            getEditableContainer: getEditableContainer,
            close: close,
            setButtonActiveMode: setButtonActiveMode,
            getToolbarElement: getToolbarElement
        };
    }

    RichTextEditor.PERMUTATION = PERMUTATION;
    RichTextEditor.TOOLBAR_ITEMS = TOOLBAR_ITEMS;

    RichTextEditor.TOOLBARS = {
        EMPTY: [],
        BASIC: [
            RichTextEditor.TOOLBAR_ITEMS.BOLD,
            RichTextEditor.TOOLBAR_ITEMS.ITALIC,
            RichTextEditor.TOOLBAR_ITEMS.UNDERLINE,
            RichTextEditor.TOOLBAR_ITEMS.DEVIDER,
            RichTextEditor.TOOLBAR_ITEMS.LINK,
            RichTextEditor.TOOLBAR_ITEMS.DEVIDER
        ]
    };

    if (!_.isUndefined(window)) {
        window.RichTextEditor = RichTextEditor;
    }

    return RichTextEditor;
});


/*
   |-------------------------------------------------------------|
   | List of spacial chars
   |-------------------------------------------------------------|
    \u00a0 or &nbsp; (non-breaking space)
    \ufeff or &#65279; (zero-width non-breaking space)
    lesser-known ones:
    \u1680​ or &#5760; (Ogham space mark)
    \u180e or &#6158; (Mongolian vowel separator)
    \u2000​ or &#8192; (en quad)
    \u2001 or &#8193; (em quad)
    \u2002 or &#8194; (en space)
    \u2003 or &#8195; (em space)
    \u2004 or &#8196; (three-per-em space)
    \u2005 or &#8197; (four-per-em space)
    \u2006 or &#8198; (six-per-em space)
    \u2007 or &#8199; (figure space)
    \u2008 or &#8200; (punctuation space)
    \u2009 or &#8201; (thin space)
    \u200a or &#8202; (hair space)
    \u2028 or &#8232; (line separator)
    \u2029 or &#8233; (paragraph separator)
    \u202f or &#8239; (narrow non-breaking space)
    \u205f or &#8287; (medium mathematical space)
    \u3000 or &#12288; (ideographic space)
    \u200b or &#8203; (zero-width breaking space)
*/
